import { BaseEntity } from ".";
import { getCachedGroupEntity } from "./GroupEntityCache";

export class CategoryEntity extends BaseEntity {
  private _groups: any;
  constructor(id: number, props: any, groups: any) {
    super(id, props);
    this._dataTypeName = "Category";
    this._groups = groups;
  }

  async toJson(expanded?: boolean, expanded_groups?: boolean): Promise<Excel.EntityCellValue> {
    const props = this.props;
    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      // - Types
      // - Category Id
      if (props.name.en) {
        entity.properties["name"] = {
          type: Excel.CellValueType.string,
          basicValue: props.name.en,
        };
        entity.text = props.name.en;
      } else {
        entity.properties["name"] = {
          type: Excel.CellValueType.string,
          basicValue: "Unknown category",
        };
        entity.text = "Unknown category";
      }
      delete entity.properties["categoryID"];
      delete entity.properties["iconID"];
      if (this._groups !== null && this._groups.length && expanded) {
        let group_array: Excel.CellValue[][] = [];
        for (const y of this._groups) {
          const entity = await getCachedGroupEntity(y.groupID);
          if (entity) {
            if (expanded_groups == true) group_array.push([await entity.toJson(true)]);
            else group_array.push([await entity.toJson()]);
          }
        }
        if (group_array.length) {
          entity.properties["groups"] = {
            type: Excel.CellValueType.array,
            elements: group_array,
          };
        }
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };
    return entity;
  }
}
